import React, { useEffect, useState } from 'react';import { Container, Typography, Grid, Box } from "@mui/material";
import { motion } from "framer-motion";
import Particles from "react-tsparticles";
import { useNavigate } from "react-router-dom";
import API from "../services/api";


//import newsImage1 from "./assets/images/newsImage1.jpg";
//import newsImage2 from "./assets/images/newsImage2.jpg";
//import newsImage3 from "./assets/images/newsImage3.jpg";

import GraffitiHeader from "../components/GraffitiHeader";
import BackgroundWords from "../components/BackgroundWords";



const News = () => {
  const navigate = useNavigate();

  const [newsData, setNewsData] = useState([]);

useEffect(() => {
  const fetchNews = async () => {
    try {
      const res = await API.get("/news");
      setNewsData(res.data);
    } catch (err) {
      console.error("Error cargando noticias:", err);
    }
  };

  fetchNews();
}, []);

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        overflow: "hidden",
        background: "linear-gradient(135deg, #1c1c1c, #2a2a2a)",
      }}
    >
      {/* Partículas */}
      <Particles
        id="tsparticles-news"
        style={{
          position: "absolute",
          inset: 0,
          zIndex: 0,
        }}
        options={{
          particles: {
            color: { value: ["#FF6F00", "#ffaa33"] },
            links: {
              enable: true,
              color: "#ffaa33",
              opacity: 0.25,
            },
            move: {
              enable: true,
              speed: 1.5,
            },
            number: {
              value: 50,
            },
            size: {
              value: {
                min: 1,
                max: 4,
              },
            },
          },
        }}
      />

      

      {/* Palabras del fondo */}
      <BackgroundWords />

      <Container
        maxWidth="lg"
        sx={{
          position: "relative",
          zIndex: 2,
          pt: 3,
          pb: 8,
        }}
      >
        {/* HERO */}
        <GraffitiHeader
          mainText="Noticias"
          backgroundText="NOTICIAS"
        />

        {/* CTA */}
        <Box
          sx={{
            textAlign: "center",
            mb: 6,
            mt: 1,
          }}
        >
          <Typography
            sx={{
              fontSize: "1.35rem",
              color: "#cfcfcf",
            }}
          >
            Quedate con la primicia.
          </Typography>

          <Typography
            sx={{
              mt: 1,
              fontSize: "1.75rem",
              fontWeight: "bold",
              background:
                "linear-gradient(90deg,#ff6e00,#ffae00)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Suscribite a nuestro newsletter 🚀
          </Typography>

          {/* Separador */}
          <Box
            sx={{
              mt: 4,
              mx: "auto",
              width: {
                xs: "80%",
                md: "420px",
              },
              height: "2px",
              background:
                "linear-gradient(90deg, transparent, rgba(255,110,0,.9), transparent)",
            }}
          />
        </Box>

        {/* GRID */}
        <Grid container spacing={4}>
          {newsData.map((news, index) => (
            <Grid item xs={12} md={6} key={news.id}>
              <motion.div
                initial={{
                  opacity: 0,
                  y: 30,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                viewport={{
                  once: true,
                }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.15,
                }}
              >
                <Box
                  onClick={() => navigate(`/news/${news.slug}`)}
                  sx={{
                    p: 2,
                    borderRadius: "14px",
                    cursor: "pointer",
                    background: "#2e2e2e",
                    transition: ".35s",

                    "&:hover": {
                      transform: "translateY(-6px)",
                      boxShadow:
                        "0 0 25px rgba(255,110,0,.45)",
                    },
                  }}
                >
                 <Box
  sx={{
    height: 220,
    borderRadius: "10px",
    overflow: "hidden",
    background: "#181818",
  }}
>
  {news.image ? (
    <img
      src={news.image}
      alt={news.title}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
      }}
      onError={(e) => {
        e.currentTarget.style.display = "none";
      }}
    />
  ) : null}
</Box>

                  <Typography
                      sx={{
                      mt: 2,
                      color: "#888",
                      fontSize: "0.85rem"
                      }}
                      >
                      {new Date(news.createdAt).toLocaleDateString("es-AR")}
                  </Typography>

                  <Typography
                    sx={{
                      mt: 2,
                      color: "#FF6F00",
                      fontWeight: "bold",
                      fontSize: "1.15rem",
                    }}
                  >
                    {news.title}
                  </Typography>

                  <Typography
                    sx={{
                      mt: 1,
                      color: "#d0d0d0",
                      lineHeight: 1.7,
                    }}
                  >
                    {news.description}
                  </Typography>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default News;